import React, {useEffect, useState} from "react";
import {Layout, Popconfirm} from "antd";
import {MDBIcon} from "mdbreact";
import {Button, Text, Tooltip} from "@nextui-org/react";
import {useCollection} from "react-firebase-hooks/firestore";
import {collection, getFirestore, query, where} from "firebase/firestore";
import Firebase from "../../Firebase/Firebase";
import Headerbar from "../../navBars/Headerbar";
import Sidebar from "../../navBars/Sidebar";
import AddContent from "./AddContent";
import {useToast} from "@chakra-ui/react";
import EditCategoryModal from "./EditCategoryModal";
import Firefetch from "../../Firebase/Firefetch";
import EditSection from "./EditSection";
import AddSectionContent from "./AddSectionContent";


const db = getFirestore(Firebase);
const { Content } = Layout;

// ─── Catalog page ─────────────────────────────────────────────────────────────
// The structural side of the storefront: categories (+ sub-categories) and
// sections. Promotional surfaces (banners, splash ads, featured products) now
// live under Promotions.

const card: React.CSSProperties = {
    background:'#fff', borderRadius:12, border:'1px solid #eee',
    boxShadow:'0 1px 4px rgba(0,0,0,.05)', overflow:'hidden',
};

const AppContent = () => {
    const toast = useToast();
    const [collapsed, setCollapsed] = useState(false);

    const [addModal, setAddModal] = useState(false);
    const [contentType, setContentType] = useState("");
    const [parentCategory, setParentCategory] = useState<string>("");

    const [editCatModal, setEditCatModal]   = useState(false);
    const [editSectModal, setEditSectModal] = useState(false);
    const [addContentModal, setAddContentModal] = useState(false);

    const [selectedCategory, setSelectedCategory] = useState<any>();
    const [selectedSection, setSelectedSection]   = useState<any>();

    const [expandedCat, setExpandedCat]   = useState<string | null>(null);
    const [expandedSect, setExpandedSect] = useState<string | null>(null);

    const [categoryArray, setCategoryArray]       = useState<any[]>([]);
    const [subCategoryArray, setSubCategoryArray] = useState<any[]>([]);
    const [sectionArray, setSectionArray]         = useState<any[]>([]);
    const [productArray, setProductArray]         = useState<any[]>([]);
    const [sellerArray, setSellerArray]           = useState<any[]>([]);

    const [categorySnapshot]    = useCollection(collection(db, 'categories'),
        {snapshotListenOptions: {includeMetadataChanges: true}});
    const [subCategorySnapshot] = useCollection(collection(db, 'subCategories'),
        {snapshotListenOptions: {includeMetadataChanges: true}});
    const [sectionSnapshot]     = useCollection(collection(db, 'sections'),
        {snapshotListenOptions: {includeMetadataChanges: true}});
    const [productSnapshot]     = useCollection(collection(db, 'products'),
        {snapshotListenOptions: {includeMetadataChanges: true}});
    const [sellerSnapshot]      = useCollection(
        query(collection(db, 'users'), where('type', '==', 'Seller')),
        {snapshotListenOptions: {includeMetadataChanges: true}});

    useEffect(() => {
        const map = (snap: any) => (snap?.docs ?? []).map((d: any) => ({...d.data(), id: d.id}));
        setCategoryArray(map(categorySnapshot));
        setSubCategoryArray(map(subCategorySnapshot));
        setSectionArray(map(sectionSnapshot));
        setProductArray(map(productSnapshot));
        setSellerArray(map(sellerSnapshot));
    }, [categorySnapshot, subCategorySnapshot, sectionSnapshot, productSnapshot, sellerSnapshot]);

    const activeCategories = categoryArray.filter(c => (c.status ?? '').toLowerCase() === 'active');
    const activeSections   = sectionArray.filter(s => (s.status ?? '').toLowerCase() === 'active');
    const subsOf = (catId: string) =>
        subCategoryArray.filter(c => c.categoryID === catId && (c.status ?? '').toLowerCase() === 'active');

    const removeSectionContent = (section: any, itemId: any) => {
        const next = {...section, content: (section.content ?? []).filter((x: any) => x.item !== itemId)};
        Firefetch.UpdateInDB("sections", section.id, next).then((result) => {
            if (result === "success") {
                toast({position:'top', title:'Removed', status:'success', duration:2500, isClosable:true});
            }
        });
    };

    const sectionContentLabel = (section: any, content: any) => {
        if (section.contentType === "Images") return {imageUrl: content.item, name: ''};
        if (section.contentType === "Products") {
            const p = productArray.find(x => x.productId === content.item);
            return {imageUrl: p?.imageUrl, name: p?.name ?? content.item};
        }
        if (section.contentType === "Sellers") {
            const s = sellerArray.find(x => x.sellerID === content.item || x.Uid === content.item);
            return {imageUrl: s?.imageUrl, name: s?.fullName ?? content.item};
        }
        return {imageUrl: '', name: content.item};
    };

    const sectionHeader = (title: string, onAdd: () => void, addLabel: string) => (
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', margin:'24px 4px 10px'}}>
            <Text b h5 size={18} style={{margin:0}}>{title}</Text>
            <Button size="sm" color="primary" auto onPress={onAdd}>
                <i className="pi pi-plus" style={{marginRight:6}}/> {addLabel}
            </Button>
        </div>
    );

    const iconBtn = (icon: string, color: any, tip: string, onPress: () => void) => (
        <Tooltip content={tip} rounded color={color === 'error' ? 'error' : 'primary'}>
            <Button auto size="xs" flat color={color} onPress={onPress}><MDBIcon icon={icon} /></Button>
        </Tooltip>
    );

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Headerbar collapsed={collapsed} setCollapsed={setCollapsed}/>
            <Layout className="site-layout">
                <Sidebar collapsed={collapsed}/>
                <Content>
                    {/* Modals */}
                    <AddSectionContent openDrawer={addContentModal} section={selectedSection}
                                       closeDrawer={setAddContentModal} products={productArray} sellers={sellerArray}/>
                    <AddContent contentType={contentType} openDrawer={addModal}
                                closeDrawer={setAddModal} products={productArray} parentCategory={parentCategory}/>
                    <EditCategoryModal openModal={editCatModal} closeModal={setEditCatModal} category={selectedCategory} />
                    <EditSection openModal={editSectModal} closeModal={setEditSectModal} section={selectedSection} />

                    <div className="mt-4 mx-4" style={{maxWidth:1200}}>
                        <div className="page-header">
                            <h4 className="page-title">Catalog</h4>
                            <span style={{color:'#888', fontSize:13}}>
                                Categories, sub-categories and home sections that structure the app.
                            </span>
                        </div>

                        {/* ── Categories ── */}
                        {sectionHeader('Categories', () => { setContentType("categories"); setAddModal(true); }, 'Add Category')}
                        <div style={{display:'grid', gap:14,
                                     gridTemplateColumns:'repeat(auto-fill, minmax(230px, 1fr))'}}>
                            {activeCategories.map(cat => {
                                const subs = subsOf(cat.id);
                                const open = expandedCat === cat.id;
                                return (
                                    <div key={cat.id} style={card}>
                                        <div style={{display:'flex', gap:12, padding:12}}>
                                            <img src={cat.imageUrl} alt={cat.name}
                                                 style={{width:54, height:54, borderRadius:10, objectFit:'cover',
                                                         background:'#ecf7fc', flexShrink:0}} />
                                            <div style={{flex:1, minWidth:0}}>
                                                <div style={{fontWeight:600, fontSize:14, whiteSpace:'nowrap',
                                                             overflow:'hidden', textOverflow:'ellipsis'}}>{cat.name}</div>
                                                <div style={{fontSize:12, color:'#999', marginTop:2}}>
                                                    {subs.length} sub-categor{subs.length === 1 ? 'y' : 'ies'}
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{display:'flex', gap:8, padding:'0 12px 12px', alignItems:'center'}}>
                                            {iconBtn('marker', 'primary', 'Edit category',
                                                () => { setSelectedCategory(cat); setEditCatModal(true); })}
                                            <Popconfirm title="Delete this category?" okText="Delete"
                                                        okButtonProps={{danger:true}}
                                                        onConfirm={() => Firefetch.DeleteFromDB("categories", cat.id)}>
                                                <Button auto size="xs" flat color="error"><MDBIcon icon="trash-alt"/></Button>
                                            </Popconfirm>
                                            <div style={{flex:1}}/>
                                            {iconBtn('plus', 'secondary', 'Add sub-category',
                                                () => { setParentCategory(cat.id); setContentType("sub-categories"); setAddModal(true); })}
                                            <Button auto size="xs" flat color="secondary"
                                                    onPress={() => setExpandedCat(open ? null : cat.id)}>
                                                <MDBIcon fas icon={open ? 'angle-up' : 'angle-down'} />
                                            </Button>
                                        </div>
                                        {open && (
                                            <div style={{borderTop:'1px solid #f1f1f1', padding:'10px 12px',
                                                         display:'flex', flexWrap:'wrap', gap:6}}>
                                                {subs.length === 0 && <span style={{color:'#bbb', fontSize:12}}>No sub-categories</span>}
                                                {subs.map(sub => (
                                                    <span key={sub.id} style={{display:'inline-flex', alignItems:'center', gap:6,
                                                          background:'#f5f7ff', borderRadius:20, padding:'4px 6px 4px 10px', fontSize:12}}>
                                                        {sub.name}
                                                        <Popconfirm title="Delete this sub-category?" okText="Delete"
                                                                    okButtonProps={{danger:true}}
                                                                    onConfirm={() => Firefetch.DeleteFromDB("subCategories", sub.id)}>
                                                            <MDBIcon icon="times-circle" style={{cursor:'pointer', color:'#c0392b'}} />
                                                        </Popconfirm>
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                            {activeCategories.length === 0 && (
                                <div style={{gridColumn:'1/-1', color:'#aaa', fontSize:13, padding:'20px 0'}}>No categories yet.</div>
                            )}
                        </div>

                        {/* ── Sections ── */}
                        {sectionHeader('Home Sections', () => { setContentType("sections"); setAddModal(true); }, 'Add Section')}
                        <div style={{display:'grid', gap:14,
                                     gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))'}}>
                            {activeSections.map(sect => {
                                const open = expandedSect === sect.id;
                                const items = sect.content ?? [];
                                return (
                                    <div key={sect.id} style={card}>
                                        <div style={{display:'flex', gap:12, padding:12}}>
                                            <img src={sect.imageUrl} alt={sect.name}
                                                 style={{width:54, height:54, borderRadius:10, objectFit:'cover',
                                                         background:'#ecf7fc', flexShrink:0}} />
                                            <div style={{flex:1, minWidth:0}}>
                                                <div style={{fontWeight:600, fontSize:14, whiteSpace:'nowrap',
                                                             overflow:'hidden', textOverflow:'ellipsis'}}>{sect.name}</div>
                                                <div style={{fontSize:12, color:'#999', marginTop:2}}>
                                                    {sect.contentType} · {items.length} item{items.length === 1 ? '' : 's'}
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{display:'flex', gap:8, padding:'0 12px 12px', alignItems:'center'}}>
                                            {iconBtn('marker', 'primary', 'Edit section',
                                                () => { setSelectedSection(sect); setEditSectModal(true); })}
                                            <Popconfirm title="Delete this section?" okText="Delete"
                                                        okButtonProps={{danger:true}}
                                                        onConfirm={() => Firefetch.DeleteFromDB("sections", sect.id)}>
                                                <Button auto size="xs" flat color="error"><MDBIcon icon="trash-alt"/></Button>
                                            </Popconfirm>
                                            <div style={{flex:1}}/>
                                            {iconBtn('plus', 'secondary', 'Add content',
                                                () => { setSelectedSection(sect); setAddContentModal(true); })}
                                            <Button auto size="xs" flat color="secondary"
                                                    onPress={() => setExpandedSect(open ? null : sect.id)}>
                                                <MDBIcon fas icon={open ? 'angle-up' : 'angle-down'} />
                                            </Button>
                                        </div>
                                        {open && (
                                            <div style={{borderTop:'1px solid #f1f1f1', padding:'10px 12px',
                                                         display:'flex', flexDirection:'column', gap:8}}>
                                                {items.length === 0 && <span style={{color:'#bbb', fontSize:12}}>No content yet</span>}
                                                {items.map((content: any, i: number) => {
                                                    const c = sectionContentLabel(sect, content);
                                                    return (
                                                        <div key={i} style={{display:'flex', alignItems:'center', gap:10}}>
                                                            <img src={c.imageUrl} alt={c.name}
                                                                 style={{width:36, height:36, borderRadius:8, objectFit:'cover', background:'#f5f5f5'}} />
                                                            <span style={{flex:1, fontSize:13, whiteSpace:'nowrap',
                                                                          overflow:'hidden', textOverflow:'ellipsis'}}>
                                                                {c.name || `image ${i + 1}`}
                                                            </span>
                                                            <Popconfirm title="Remove this item?" okText="Remove"
                                                                        okButtonProps={{danger:true}}
                                                                        onConfirm={() => removeSectionContent(sect, content.item)}>
                                                                <Button auto size="xs" flat color="error"><MDBIcon icon="trash-alt"/></Button>
                                                            </Popconfirm>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                            {activeSections.length === 0 && (
                                <div style={{gridColumn:'1/-1', color:'#aaa', fontSize:13, padding:'20px 0'}}>No sections yet.</div>
                            )}
                        </div>
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default AppContent;
